document.documentElement.classList.add('js');

document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href*="#"]');
  if (!link) return;
  var url = new URL(link.href, window.location.href);
  if (url.pathname !== window.location.pathname || !url.hash) return;
  var target = document.querySelector(url.hash);
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  history.pushState(null, '', url.hash);
});
